<template>
  <layout>
    <!--城市选择区-->
    <template v-slot:pageLeft>
      <QHleftcity @change="change" @cityLoading="cityLoading" ref="QHleftcity"></QHleftcity>
    </template>
    <!--城市选择区 end-->

    <!--总统计区-->
    <template v-slot:pageTab>
      <div class="headerA flex-center">
        <div class="flex-center-col">
          <font class="fontColor">排放单位</font>
          <span>共{{ total.thisCount400 }}个</span>
        </div>
      </div>
      <div class="headerB flex-between"  v-if="dataLoading">        
      </div>
    </template>
    <!--总统计区 end-->

    <!--搜索及功能区-->
    <template v-slot:pageSearch>
      <ul class="tab">
        <li>
          <Select v-model="searchMap.formType" @on-change="search" slot="prepend" style="width: 90px">
            <Option value="100">全部单位</Option>
            <Option value="100">工程项目</Option>
            <Option value="200">临时收集点</Option>
            <Option value="300">移动收集箱</Option>
            <Option value="400">物业单位</Option>
            <Option value="500">居民</Option>
          </Select>
        </li>
        <li style="width: 280px">
          <Input size="small" v-model="searchMap.keyword" placeholder="请输入关键词">
            <Select v-model="searchMap.likeNameA" slot="prepend" style="width: 90px">
              <Option value="name">单位名称</Option>
              <Option value="addressFull">所在地区</Option>
            </Select>
          </Input>
        </li>
        <li>
          <Button type="warning" size="small" @click="search">查询</Button>
        </li>
        <li>
          <Button type="primary" @click="uploadExcel" size="small" >导出公司</Button>
        </li>
      </ul>
    </template>
    <!--搜索及功能区 end-->

    <!--主体呈现区-->
    <template v-slot:pageContent>
      <QHTable :total="total['pageCount'] || 0" :pageThis="pageThis">
        <Table :columns="columns" :data="list" @on-selection-change="(event) => $tableSeletChange(event, pageThis)" :loading="loading" class="QHTableList">
          <!--分割区-->
          <template slot-scope="{ row }" slot="paifangAuth">
            <Tag color="cyan" v-if="row.paifangAuth == 100">运营中</Tag>
            <Tag color="red" v-if="row.paifangAuth == 200">已关闭</Tag>
            <Tag color="red" v-if="row.paifangAuth == 400">审核中</Tag>
            <Tag color="red" v-if="row.paifangAuth == 500">已关闭</Tag>
          </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="orgStatus">
            <Tag color="cyan" v-if="row.status == 100">已开通</Tag>
            <Tag color="red" v-if="row.status == 200">已关闭</Tag>
            <Tag color="red" v-if="row.status == 300">未开通</Tag>
            <Tag color="red" v-if="row.status == 400">审核中</Tag>
            <Tag color="red" v-if="row.status == 500">未通过</Tag>
          </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="allQualificationsCount">
            <b style="font-size: 18px; color: #01aaed" v-if="row.allQualificationsCount > 0">{{ row.allQualificationsCount }}</b>
            <b style="font-size: 18px; color: #bbb" v-if="row.allQualificationsCount == 0">{{ row.allQualificationsCount }}</b>
            <b style="color: #bbb">/</b>
            <b style="font-size: 18px; color: #ed4014" v-if="row.invalidQualificationsCount > 0">{{ row.invalidQualificationsCount }}</b>
            <b style="font-size: 18px; color: #bbb" v-if="row.invalidQualificationsCount == 0">{{ row.invalidQualificationsCount }}</b>
          </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="action">
            <Button type="warning" size="small" @click="$goQiyeBigscreen(row.id,3)">详情</Button>
          </template>
        </Table>
      </QHTable>
    </template>
    <!--主体呈现区 end-->

    <!--弹窗组件区-->
    <template v-slot:pageBlock>
      <detailed ref="detailed"></detailed>
    </template>
    <!--弹窗组件区 end-->
  </layout>
</template>
<script>
import detailed from "./block/detailed/detailed";
export default {
  components: {
    detailed,
  },
  data() {
    return {
      //列表配置项(loading加载效果,columns列,list数据,selectedRows选中,total统计项)@@@@@@@@@@@
      list: [],
      loading: false,
      pageThis: this,
      selectedRows: [],
      total: {},
      selectedRowsMore: [],
      columns: this.$colFilter([
        {
          title: "排放单位",
          key: "name",
          minwidth: 280,
          ellipsis: true,
          tooltip: true,
          resizable: true,
        },
        {
          title: "区县",
          key: "districtName",
          width: 120,
          align: "center",
        },
        {
          title: "街道",
          key: "streetName",
          width: 120,
          align: "center",
        },
        {
          title: "资质/异常",
          width: 120,
          align: "center",
          slot: "allQualificationsCount",
        },
        {
          title: "联系姓名",
          key: "contactName",
          width: 100,
          align: "center",
        },
        {
          title: "联系电话",
          key: "contactTel",
          width: 110,
          align: "center",
        },
        {
          title: "创建时间",
          key: "created",
          width: 135,
          align: "center",
          render: (h, parameter) => {
            var row = parameter.row;
            let time = this.$timeFmt(row.created, "YYYY-MM-DD HH:mm");
            return h("span", time);
          },
        },
        {
          title: "操作",
          key: "action",
          fixed: "right",
          width: 80,
          slot: "action",
          align: "center",
        },
      ]),

      //搜索配置项@@@@@@@@@@@@@@@@@@@@@@@
      searchMap: {
        likeNameA: "name",
        keyword: "",
        formType: this.$getLocalStorage("formType") || 100,
        paifangAuth: 100,
        pageNo: 1,
        pageSize: 25,
      },
      total: {},
      //其他逻辑配置项@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
      dataLoading: false,
      dataName: "",
    };
  },

  // +----------------------------------------------------------------------
  // | mounted
  // +----------------------------------------------------------------------
  mounted() {
     
    this.$refs.QHleftcity.int();
  },

  methods: {
    // +----------------------------------------------------------------------
    // | 切换数据地址数据
    // +----------------------------------------------------------------------
    change(res) {
      this.searchMap.code = res.code;
      this.searchMap.level = res.level;
      this.dataName = res.name;
      this.dataLoading = false;
    },

    cityLoading(res) {
      this.searchMap.code = res.code;
      this.searchMap.level = res.level;
       
      this.getList();
    },

    // +----------------------------------------------------------------------
    // | 列表
    // +----------------------------------------------------------------------
    getList() {
      var that = this;
      var https = {
        type: "isPagelist",
        api: this.$api.getOrgpaifangList,
        parameter: this.searchMap,
      };
      this.$httpsApi(https, function () {
        that.dataLoading = true;
      });
    },

     // +----------------------------------------------------------------------
        // | 导出excel
        // +----------------------------------------------------------------------
        uploadExcel() {
            this.$loading(true);
            this.searchMap.ids = this.selectedRows;
            var obj1 = this.searchTemp;
            var obj2 = this.searchMap;
        
            this.searchMap = { ...obj2, ...obj1 };
            
            var parameter = this.searchMap;
            var url = "/zxbigscreen/Orgpaifang/uploadExcel";
            var fileName = "排放单位.xlsx";
            this.$downLoad(url,parameter,fileName);
            this.$loading(false);
        },
    // +----------------------------------------------------------------------
    // | 搜索
    // +----------------------------------------------------------------------
    search(paifangAuth) {
      if (!this.$isblank(paifangAuth)) {
        this.searchMap.paifangAuth = paifangAuth;
      }
      this.$setLocalStorage("formType", this.searchMap.formType);
      this.getList();
    },
  },
};
</script>
